import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUpSmall = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M9.28125 7.28125L4.28125 12.2812C3.875 12.6562 3.875 13.3125 4.28125 13.6875C4.65625 14.0938 5.3125 14.0938 5.6875 13.6875L10 9.40625L14.2812 13.6875C14.6562 14.0938 15.3125 14.0938 15.6875 13.6875C16.0938 13.3125 16.0938 12.6562 15.6875 12.2812L10.6875 7.28125C10.3125 6.875 9.65625 6.875 9.28125 7.28125Z"
	})
});
const ForwardRef = forwardRef(SvgArrowUpSmall);
export default ForwardRef;
